export default __webpack_public_path__ + "static/media/plans.e3c2b70f.svg";